import {
	AnyMenuItem,
	BrandResource,
	Id,
	ImageResource,
	LocalConfigState,
	RemoteConfigState,
	useDynamicConfig,
} from "@dgs/core";

export type AdobeAnalyticsThirdPartyScript = { src: string } & Record<string, string>;

export interface ConfigState extends LocalConfigState, RemoteConfigState {
	analyticsUrl: string;
	productData: {
		htmlTitle: string;
		startPageMenuItem: AnyMenuItem | null;
		defaultRegistrationFormId: Id | null;
		enableAnalytics: boolean;
		enableAdobeAnalytics: boolean;
		adobeAnalyticsThirdPartyScripts: AdobeAnalyticsThirdPartyScript[] | null;
		adobeAnalyticsStcCodeDataFieldId: Id | null;
		enableSearchEngineIndexing: boolean;
		logoImage: ImageResource | null;
	};
	dataFieldSettings: {
		emailId: Id | null;
		allowedMimeTypes: string[];
	};
	brand: BrandResource | null;
	productTranslations: { locale: string; value: string }[];
}

export const useConfig = () => {
	return useDynamicConfig<ConfigState>();
};
